import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

  initialize() {
    super.initialize();
    this.popupLoading = false;
    this.popupDismissLoading = false;
    this.currentLanguageCode = document.documentElement.lang.split('-')[0];
  }

  connect() {
    this.element.addEventListener('modal:before-close:iframe-popup', this.onPopupDismiss);
    this.element.addEventListener('modal:before-close:global-popup', this.onPopupDismiss);
    this.fetchPopup();
  }

  onPopupDismiss(event) {
    if (this.popupDismissLoading) {
      return;
    }

    this.popupDismissLoading = true;

    const element = event.target;
    const globalPopup = element.querySelector('[data-global-popup-id]');

    if (globalPopup) {
      const popupID = globalPopup.dataset.globalPopupId;

      if (popupID) {
        try {
          axios.post('/wp-json/api/dismiss-global-popup', { 'popupId': popupID });
        } catch (error) {
          console.warn(error);
        }
      }
    }

    this.popupDismissLoading = false;
  }

  async fetchPopup() {
    if (this.popupLoading) {
      return;
    }

    this.popupLoading = true;

    try {
      let response = await axios.get('/wp-json/api/get-global-popup?rest_language=' + this.currentLanguageCode);
      response = response.data.data;

      if (response && response.content && response.type) {
        let popup;

        switch (response.type) {
          case 'iframe':
            popup = document.getElementById('iframe-popup');
            break;
          case 'persistent':
            popup = document.getElementById('persistent-popup');
            break;
          case 'default':
            popup = document.getElementById('global-popup');
            break;
        }

        if (popup) {
          if (response.type === 'persistent') {
            const persistentContent = popup.querySelector('.persistent-popup-content');

            if (persistentContent) {
              const stickyFooters = document.querySelectorAll('.sticky-footer');
              let stickersHeight = 0;

              for(const footer of stickyFooters) {
                const hidden = footer.classList.contains('d-none-important');
                footer.classList.remove('d-none-important');
                const boundingClientRect = footer.getBoundingClientRect();
                stickersHeight += parseInt(boundingClientRect.height.toFixed());

                if (hidden) {
                  footer.classList.add('d-none-important');
                }
              }

              popup.style.bottom = (stickersHeight + 20) + 'px';
              persistentContent.innerHTML = response.content;
              popup.classList.remove('d-none');

              if (response.options.width) {
                popup.style.width = response.options.width + 'px';
              }
            }
          } else {
            const popupController = Stimulus.getControllerForElementAndIdentifier(popup, 'modal');

            if (popupController) {
              popup.querySelector('.modal-inner').innerHTML = response.content;
              popupController.showModal();
            }
          }
        }
      }

    } catch (error) {
      console.warn(error);
    }

    this.popupLoading = false;
  }

  disconnect() {
    this.element.removeEventListener('modal:after-close:iframe-popup', this.onPopupDismiss);
    this.element.removeEventListener('modal:after-close:global-popup', this.onPopupDismiss);
    super.disconnect();
  }
}
